<template>
  <div class="page-mine">
    <div class="mine-content">
      <div class="content-avatar">
        <img :src="headerurl" alt="头像" v-if="headerurl">
        <img src="@/assets/images/avatar.png" alt="头像" v-else>
      </div>
      <div class="content-username">{{nickname ? nickname : '预约会员'}}</div>
      <router-link tag="div" class="content-item" to='/list'>
        <span>我的预约</span>
        <!-- <img src="" alt=""> -->
      </router-link>
    </div>
    <v-bottom></v-bottom>
  </div>
</template>

<script type="text/javascript">
import Bottom from '@/components/Bottom'
import { Indicator } from 'mint-ui'
export default{
  components: {
    'v-bottom': Bottom
  },
  data () {
    return {
      headerurl: '',
      nickname: '',
      phone: ''
    }
  },
  methods: {
    async getUserInfo () {
      let that = this
      try {
        Indicator.open()
        let result = await that.$api({
          method: 'get',
          url: '/user/info'
        })
        Indicator.close()
        if (result.code === 2000 && result.result) {
          that.setSession('nickname', result.result.nickName || '')
          that.setSession('headsUrl', result.result.headsUrl || '')
          that.nickname = result.result.nickName
          that.headerurl = result.result.headsUrl
        } else {
          console.log(result.message)
        }
      } catch (e) {
        Indicator.close()
        console.log(e)
      }
    }
  },
  created () {
    this.headerurl = this.getSession('headsUrl')
    this.nickname = this.getSession('nickname')
    if (!this.headerurl) {
      this.getUserInfo()
    }
    document.title = '我的'
  }
}
</script>

<style type="text/css" lang="scss" scoped>
.page-mine{
  width: 100%;
  height: 100%;
  position: relative;
  background: url('../assets/images/bg-geren@2x.png') no-repeat top;
  background-color: #FFFFFF;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .mine-content{
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .content-avatar{
      width: .6rem;
      height: .6rem;
      border-radius: .3rem;
      overflow: hidden;
      margin-top: .22rem;
      img{
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .content-username{
      margin-top: .08rem;
      font-size: .16rem;
      color: #FFFFFF;
      letter-spacing: 0.5px;
      line-height: .22rem;
    }
    .content-item{
      margin-top: .82rem;
      width: 3.45rem;
      height: 1rem;
      background: #FFFFFF;
      box-shadow: 0 1px 4px 0 rgba(58,127,255,0.53);
      border-radius: 4px;
      background: url('../assets/images/wodyuyue@2x.png') no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      span{
        font-size: .16rem;
        color: #456CEF;
        letter-spacing: 0.5px;
        margin-left: .86rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Mine.vue